import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "./FloatingWhatsApp.css";

const FloatingWhatsApp = ({
    phone = "917888570416",
    message = "Hello, I'd like to know more about the courses at Sri Guru Arjun Dev Ji Group of Institutes.",
}) => {
    const href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
            className="floating-whatsapp"
        >
            <FontAwesomeIcon icon={faWhatsapp} />
        </a>
    );
};

export default FloatingWhatsApp;
